import { useQuery } from '@tanstack/react-query';
import { payoutService } from '../services/payout.service';

export const ELIGIBLE_PSPS_KEY = ['payouts', 'eligible-psps'] as const;

/**
 * Doc 51 Phase 5 — options PSP pour la Popup 1. Chargé à la demande (`enabled`)
 * quand le vendeur ouvre le parcours « Configurer / ajouter un moyen de versement ».
 */
export function useEligiblePsps(enabled: boolean) {
  return useQuery({
    queryKey: ELIGIBLE_PSPS_KEY,
    queryFn: () => payoutService.getEligiblePsps(),
    enabled,
    // Refetch à chaque ouverture : la disponibilité des connecteurs et le pays du
    // vendeur peuvent changer entre deux ouvertures du parcours.
    staleTime: 0,
    refetchOnMount: 'always',
  });
}
